export default "/8522fe2631ecefb1e3967be9883671f05392a386/74cc88c7571ddfe8037db442e45677ad.svg";